//Library Imports
import { Col, Row, Modal } from "antd";
import React, { useState } from "react";

//Local Imports
import { ReactComponent as Cross } from "../../../assets/img/icons/cross.svg";
import videoThumb from "../../../assets/img/videoThumb.png";

//Style Imports
import styled from "styled-components";

// type Props = {
//   title: string;
//   icon: string;
// }

const AutomationVideoCard = (props: Props) => {
  // const { title, icon} = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Wrapper onClick={showModal} style={{ backgroundImage: `url(${videoThumb})` }}>
        <Row justify="space-around" align="middle" className="video-action">
          <Col span={24} className="d-flex flex-column align-items-center">
            {/* <h4>{title}</h4> */}
            {/* <img src={icon} alt="icon" /> */}
            &nbsp;
          </Col>
        </Row>
      </Wrapper>
      <StyledModal
        centered
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closeIcon={<Cross />}
        width={650}
        wrapClassName="workflow-modal"
        maskClosable={false}
        destroyOnClose={true}
      >
        <div className="text-center">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/JGAYBQo-cSc"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </StyledModal>
    </>
  );
};

export default AutomationVideoCard;

const Wrapper = styled.div`
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 8px;
  .video-action {
    background-color: transparent;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid #dddddd;
    height: 100%;
    cursor: pointer;
    h4 {
      color: #001823;
      font-weight: 500;
      font-family: "Roboto Slab", serif;
      font-size: 18px;
      letter-spacing: -0.45px;
      margin: 0 0 14px 0;
    }
    img {
      max-width: 42px;
    }
  }
`;

const StyledModal = styled(Modal)`
  /* .workflow-modal {
    }
  } */
  .ant-modal-content {
    border-radius: 8px;
    box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.0821427);
  }
`;
